import { SelectSymbolPrice } from 'components/form/compobox/select-symbolprice'
export default function Symbol({brrand,index}) {
  return (
    <div className="space-y-2 border border-dashed p-2 rounded">
      <SelectSymbolPrice washType="wash" brrand={brrand} index={index} />
      <SelectSymbolPrice washType="bleach" brrand={brrand} index={index} />
      <SelectSymbolPrice washType="tumble" brrand={brrand} index={index} />
      <SelectSymbolPrice washType="iron" brrand={brrand} index={index} />
      <SelectSymbolPrice washType="dry" brrand={brrand} index={index} />
    </div>
  )
}
